import { FC } from 'react';
import { Box, Typography, Switch } from '@mui/material';
import { Preference } from '@libs/models';

interface EmployerPreferencesProps {
  localPreferences: Partial<Preference>;
  handleToggle: (field: keyof Preference, value: boolean) => Promise<void>;
  isUpdating: boolean;
}

export const EmployerPreferences: FC<EmployerPreferencesProps> = ({ localPreferences, handleToggle, isUpdating }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2.5,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="body1" fontWeight={500} sx={{ mb: 0.5 }}>
          Job Application Notifications
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          Get notified when a job seeker applies to your job postings
        </Typography>
      </Box>
      <Switch
        checked={localPreferences.notificationEmployerJobseekerApplied ?? true}
        onChange={(e) => handleToggle('notificationEmployerJobseekerApplied', e.target.checked)}
        disabled={isUpdating}
      />
    </Box>
  );
};
